// context/BillsContext.js
import React, { createContext, useContext, useState, useCallback } from "react";
import { fetchPatientBills } from "../utils/patients/fetchPatientsBills";
import { fetchPatientBillsAlt } from "../utils/patients/fetchPatientBillsAlt";
import { fetchPatientPendingBills } from "../utils/patients/findpatientpendingBills";
import useProfileStore from "../store/patient/profileStore";

const BillsContext = createContext(null);

export const BillsProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [userBills, setUserBills] = useState([]);
  const [recurring, setRecurring] = useState([]);
  const { profile } = useProfileStore();

  const findPatientBills = useCallback(async () => {
    if (!profile?.id) return;
    setLoading(true);
    try {
      const response = await fetchPatientBills(profile.id);
      setUserBills(response.data);
      console.log(response.data);
    } catch (err) {
      console.error(err);
      if (err?.response?.status === 401) {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        localStorage.removeItem("tokenV2");
        localStorage.removeItem("userId");
        window.location.href = "/pages/signin2";
      }
    } finally {
      setLoading(false);
    }
  }, [profile?.id]);

  const findPatientPendingBills = useCallback(async () => {
    if (!profile?.id) return;
    setLoading(true);
    try {
      const response = await fetchPatientPendingBills(profile.id);
      setUserBills(response.data);
      setRecurring(response.data);
      console.log(response.data);
    } catch (err) {
      console.error(err);
      if (err?.response?.status === 401) {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        localStorage.removeItem("tokenV2");
        localStorage.removeItem("userId");
        window.location.href = "/pages/signin2";
      }
    } finally {
      setLoading(false);
    }
  }, [profile?.id]);

  const findPatientBillsAlt = useCallback(async () => {
    if (!profile?.id) return;
    setLoading(true);
    try {
      const response = await fetchPatientBillsAlt(profile.id);
      setUserBills(response.data);
      setRecurring(response.data);
      console.log(response.data);
    } catch (err) {
      console.error(err);
      if (err?.response?.status === 401) {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        localStorage.removeItem("tokenV2");
        localStorage.removeItem("userId");
        window.location.href = "/pages/signin2";
      }
    } finally {
      setLoading(false);
    }
  }, [profile?.id]);

  return (
    <BillsContext.Provider
      value={{
        findPatientBills,
        findPatientBillsAlt,
        findPatientPendingBills,
        userBills,
        recurring,
        loading,
      }}
    >
      {children}
    </BillsContext.Provider>
  );
};

export const useBills = () => {
  const context = useContext(BillsContext);
  if (!context) {
    throw new Error("useBills must be used within a BillsProvider");
  }
  return context;
};
